module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./TemplateDetailView.jsx"));
	}, "TemplateDetail");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=TemplateDetail!./src/pages/bundle-appResource-mgmt/TemplateDetail/TemplateDetailView.jsx
// module id = ./node_modules/bundle-loader/index.js?lazy&name=TemplateDetail!./src/pages/bundle-appResource-mgmt/TemplateDetail/TemplateDetailView.jsx
// module chunks = 43